__turbopack_context__.v({
  "className": "plus_jakarta_sans_f4c00a81-module__xP-Ckq__className",
  "variable": "plus_jakarta_sans_f4c00a81-module__xP-Ckq__variable",
});
